import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse } from '@fortawesome/free-solid-svg-icons';
import { TbBookmarkFilled, TbBookmarkOff } from "react-icons/tb";
import commonFunc from './common'
const { findMatchingRoute } = commonFunc;
var _ = require('lodash');

const homePath = process.env.REACT_APP_ROOT_HOSTNAME ? '/' : '/app'

function Breadcrumb() {
  const location = useLocation();
  const [favoritePage, setFavoritePage] = useState(false)
  const [isHomePage, setHomePage] = useState(true)
  const matchedRoute = findMatchingRoute(location.pathname);
  const parentMenu = matchedRoute.parent;
  const childMenu = matchedRoute.child;
  const pageName = childMenu?.pageTitle || childMenu?.name || parentMenu?.name
  const pageIcon = childMenu?.icon
  const pageDescription = childMenu?.description

  const handleFavorite = () => {
    let currentFavorites = localStorage.getItem('my-favorites');
    if (currentFavorites) {
      currentFavorites = JSON.parse(currentFavorites)
    } else {
      currentFavorites = []
    }
    const currentPath = location.pathname
    if (currentFavorites.includes(currentPath)) {
      _.remove(currentFavorites, (e) => e === currentPath)
      commonFunc.notifySuccess('Removed from Bookmark successfully!')
      setFavoritePage(false)
    } else {
      currentFavorites.push(currentPath)
      commonFunc.notifySuccess('Added to Bookmark successfully!')
      setFavoritePage(true)
    }
    localStorage.setItem('my-favorites', JSON.stringify(currentFavorites))
  }

  useEffect(() => {
    const currentPath = location.pathname
    let currentFavorites = localStorage.getItem('my-favorites');
    if (currentFavorites) {
      currentFavorites = JSON.parse(currentFavorites)
    } else {
      currentFavorites = []
    }
    const thisPathIsFavorite = currentFavorites.includes(currentPath)
    setFavoritePage(thisPathIsFavorite)
    setHomePage([homePath].includes(currentPath))
  }, [location])

  return (
    <div className="mb-4 col-span-full xl:mb-2">
      <nav className="flex mb-5" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 text-sm font-medium md:space-x-2">
          <li className="inline-flex items-center">
            <Link
              to={homePath}
              className="inline-flex items-center text-gray-700 hover:text-primary-600 dark:text-gray-300 dark:hover:text-white"
            >
              <FontAwesomeIcon icon={faHouse}/>
              { ` `}&nbsp;&nbsp;Home
            </Link>
          </li>
          { ![homePath].includes(location.pathname) && parentMenu && (
            <li>
              <div className="flex items-center">
                <svg
                  className="w-6 h-6 text-gray-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <Link
                  to="#"
                  className="ml-1 text-gray-700 hover:text-primary-600 md:ml-2 dark:text-gray-300 dark:hover:text-white"
                >
                  { parentMenu.name }
                </Link>
              </div>
            </li>
          )}
          { childMenu && (
            <li>
              <div className="flex items-center">
                <svg
                  className="w-6 h-6 text-gray-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <span
                  className="ml-1 text-gray-400 md:ml-2 dark:text-gray-500"
                  aria-current="page"
                >
                  { childMenu.name }
                </span>
              </div>
            </li>
          )}
        </ol>
      </nav>
      <div className='flex'>
        { !isHomePage && (
          <div className=''>
            <h1 className="text-xl text-blue-700 font-semibold sm:text-2xl dark:text-gray-200">
              { pageIcon }
              <span
                className="flex-1 ml-3 text-left whitespace-nowrap text-gray-900 dark:text-gray-200"
              >
                { pageName }
              </span>
            </h1>
          </div>
        ) }
        <div className='text-right'>
          { !isHomePage && (
            <button
              type="button"
              data-tooltip-target="tooltip-bookmark"
              data-tooltip-placement="left"
              onClick={handleFavorite}
              className='text-gray-500 dark:text-gray-200 ml-4 text-2xl'
            >
              { !favoritePage && <TbBookmarkOff style={{fontSize: '1.5rem'}} className='svg-inline--fa fa-text-width' /> }
              { favoritePage && <TbBookmarkFilled style={{fontSize: '1.5rem'}} className='svg-inline--fa fa-text-width' /> }
              <span className="sr-only">Favorite</span>
            </button>
          ) }
          
          <div
            id="tooltip-bookmark"
            role="tooltip"
            className="absolute z-10 invisible inline-block w-auto px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700"
          >
            { favoritePage ? 'Remove from Bookmark' : 'Add to Bookmark' }
            <div className="tooltip-arrow" data-popper-arrow="" />
          </div>
        </div>
      </div>
      { pageDescription && (
        <p className="mt-4 p-2 text-gray-500 dark:text-gray-400">
          { !Array.isArray(pageDescription) && (
            <p className="text-gray-500 dark:text-gray-400">
              { pageDescription }
            </p>
          ) }
          { Array.isArray(pageDescription) && (
            pageDescription.map((desc, idex) => {
              return (
                <p key={idex} className="text-gray-500 dark:text-gray-400">
                  { desc }
                </p>
              )
            })
          )}
        </p>
      )}
    </div>
  )
}

export default Breadcrumb;
